import PersonIcon from "@mui/icons-material/Person";

import {
  Box,
  Button,
  Typography,
  Modal,
  Grid,
  FormControl,
  OutlinedInput,
  InputAdornment,
  FormHelperText,
  Divider,
} from "@mui/material";
import GoogleIcon from "@mui/icons-material/Google";
import { Carousel } from 'react-responsive-carousel';
import "react-responsive-carousel/lib/styles/carousel.min.css";
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router";
import CloseIcon from "@mui/icons-material/Close";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { useDispatch, useSelector } from "react-redux";
import CancelIcon from "@mui/icons-material/Cancel";
import { getGusinessProfile } from "../employeeInfo/busnessProfileModalapi";
import { ModalHeader } from "../../common/modalHeader";
import MediaCardInput from "../../common/mediaCardInput";
import ImageCarousel from "../../common/caurasal";
import { getAllIncentive } from "../payment/paymentApi";
import { forEach } from "lodash";
import { useTheme } from "@mui/material/styles";
import { styled } from "@mui/material/styles";
const ProfileModal = ({ open, setOpen, modelData }) => {
  const serviceViceSearch = useSelector(
    (state) => state.reducer.serviceViceSearch
  );
  const navBarInputFields = useSelector(
    (state) => state.reducer.navBarInputFields
  );
  const [searchValue, setSeacrchValue] = useState("");
  const [indexTableItem, setIndexTableItem] = useState();
  const userDetail = useSelector((state) => state.reducer.userDetail);

  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [profileInfo,setProfileInfo]=useState(null)
  const [employee,setEmployee]=useState([])

  //
  useEffect(() => {
    if (userDetail) {
      getGusinessProfile(userDetail, (res) => {
        console.log("res = profileData", res?.data?.data);
        setProfileInfo(res?.data?.data)
      });
      getAllIncentive((data)=>{
        data?.data?.data?.list.forEach(element => {
          if(element.specialization != null || element.achievements != null || element.skillSet != null || element.overview != null){
            setEmployee((prev) => [...prev,element])
          }
        });
      })
    }
  }, [userDetail, open]);

  const StyledCarouselRoot = styled("div")(({ theme }) => ({
    width: "100%",
    maxWidth: "100%",
    display: "flex",
    justifyContent: "center",
  }));
  
  const StyledCarouselSlider = styled(Carousel)(({ theme }) => ({
    width: "100% !important",
    ".carousel-slider": {
      width: "100% !important",
    },
    ".control-prev, .control-next": {
      backgroundColor: theme.palette.secondary.main + " !important",
      borderRadius: "50%",
      width: "40px !important",
      height: "40px !important",
    }
  }));

  return (
    <Modal
      open={open}
      onClose={() => setOpen(false)}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <Box
        sx={{
          background: "white",
          padding: "10px",
          width: {
            xs: "90vw",
            sm: "50vw",
            lg: "30vw",
          },
          borderRadius: "10px",
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
        }}
      >
        <ModalHeader title="Business Profile" />
        <Box>
          {/* <Typography sx={{textAlign:'center'}} variant='h6'>Media Links</Typography> */}
          {/* <Divider/> */}
          <Grid
            container
            sx={{
              overflowY: "scroll",
              maxHeight: "70vh",
              borderTopLeftRadius: "20px",
              pt: 1,
            }}
          >
            <Grid
              item
              xs={12}
              sx={
                {
                  // textAlign:"center"
                }
              }
            >
              <Typography
                variant="h4"
                sx={{
                  textAlign: "center",
                }}
                color="secondary"
              >
                Amol Wad{" "}
              </Typography>

              {/* de  */}
            </Grid>
            <Grid
              item
              xs={12}
              sx={{
                textAlign: "center",
              }}
            >
              <Typography variant="h7" color="primary">
                pune{" "}
              </Typography>
            </Grid>
            <Grid
              item
              xs={12}
              sx={{
                textAlign: "center",
              }}
            >
              <Typography variant="h7" color="primary">
                {" "}
                9765232115{" "}
              </Typography>
            </Grid>
            <Grid item xs={12}>
            <MediaCardInput
                title={"Profile Id"}
                url={userDetail?.profileId} iIcon={<PersonIcon/>} value={userDetail?.profileId} setValue={() => { }} />

            </Grid>
            <Grid item xs={12}>
                <Typography variant="h6" color="primary"> Specilization </Typography>
            </Grid>
                        <Grid item xs={12}>
                <Typography variant="h7" > {profileInfo?.specialization} </Typography>
            </Grid>
            <Grid item xs={12}>
                <Typography variant="h6" color="primary"> Achievements </Typography>
            </Grid>
                        <Grid item xs={12}>
                <Typography variant="h7" > {profileInfo?.achievements} </Typography>
            </Grid>
            <Grid item xs={12}>
                <Typography variant="h6" color="primary"> Overview </Typography>
            </Grid>
                        <Grid item xs={12}>
                <Typography variant="h7" > {profileInfo?.overview} </Typography>
            </Grid>
            <Grid item xs={12}>
                <Typography variant="h6" color="primary"> Terms and Conditions </Typography>
            </Grid>
                        <Grid item xs={12}>
                <Typography variant="h7" > {profileInfo?.termsAndConditions} </Typography>
            </Grid>
            <Grid container item xs={12} sx={{ width: "100%" }}>
              <StyledCarouselRoot sx={{ mt: 4 }}>
                <StyledCarouselSlider
                  autoPlay
                  infiniteLoop
                  showThumbs={false}
                  showIndicators={false}
                  showStatus={false}
                  width="100%"
                >
                  {employee.map((ele, index) => (
                    <div key={index}>
                      <Grid container alignItems="center">
                        <Grid item xs={6}>
                          <PersonIcon color="secondary" sx={{ fontSize: 50 }} />
                        </Grid>
                        <Grid item xs={6}>
                          <Typography variant="h6" color="secondary" textAlign="start">{ele.name}</Typography>
                          <Typography variant="body1" color="primary" textAlign="start">{ele.specialization}</Typography>
                          <Typography variant="body1" color="primary" textAlign="start">{ele.skillSet}</Typography>
                          <Typography variant="body1" color="primary" textAlign="start">{ele.overview}</Typography>
                        </Grid>
                      </Grid>
                    </div>
                  ))}
                </StyledCarouselSlider>
              </StyledCarouselRoot>
            </Grid>
            

          </Grid>
        </Box>
      </Box>
    </Modal>
  );
};
export default ProfileModal;
